import { InjectionToken } from "@angular/core";

export const PLAINLIST_STATE_PROP = new InjectionToken<string>("PLAINLIST_STATE_PROP");
export const plainListStatePropProvider = {
    provide: PLAINLIST_STATE_PROP,
    useValue: "commonPlainLists",
};

export const DATALIST_STATE_PROP = new InjectionToken<string>("DATALIST_STATE_PROP");
export const datalistStatePropProvider = {
    provide: DATALIST_STATE_PROP,
    useValue: "commonDatalists",
};

export const ACCORDIONLIST_STATE_PROP = new InjectionToken<string>("ACCORDIONLIST_STATE_PROP");
export const accordionListStatePropProvider = {
    provide: ACCORDIONLIST_STATE_PROP,
    useValue: "commonAccordionLists",
};
